/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import StudioFormSkeleton from './StudioFormSkeleton';
import { useStudioForm } from './useStudioForm';
import { SelectField } from '../../../../Components/FormFields/SelectField';
import StudioMap from './Components/StudioMap';

/**
 * StudioForm Component
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function StudioForm(props) {
  const { formField: { studioId } } = props;
  const { t } = useTranslation('translations');
  const {
    isLoading,
    studioData,
    setStudioToFormikContext,
    getStudioById,
    getMappedStudioData,
    currentStudioId,
  } = useStudioForm();
  /**
   * Render form elements
   * @returns {JSX.Element}
   */
  const renderFormElements = () => {
    if (isLoading) {
      return <StudioFormSkeleton />;
    }

    return (
      <SelectField
        name={studioId.name}
        label={studioId.label}
        data={getMappedStudioData(studioData)}
        onChange={(evt) => {
          setStudioToFormikContext(getStudioById(evt.target.value));
        }}
        fullWidth
        required
      />
    );
  };

  return (
    <Grid pt={8} container direction="row-reverse" spacing={4}>
      <Grid item xs={12} lg={7}>
        <Typography variant="h1">
          {t('onlineMembership')}
        </Typography>
        <Typography variant="h4">
          #createexcitement #whoareyou
        </Typography>
        <Typography mt={6} variant="h5" mb={1}>
          1.
          {' '}
          {t('stepOneHeader')}
        </Typography>
        {renderFormElements()}
      </Grid>
      <Grid item xs={12} lg={5}>
        <StudioMap
          onStudioSelect={setStudioToFormikContext}
          studioId={currentStudioId}
        />
      </Grid>
    </Grid>
  );
}

StudioForm.propTypes = {
  formField: PropTypes.object.isRequired,
};
